
import ExternalConfiguration, { DomainsKeys } from '../external-configuration';

import { SrcTypes } from './Configuration';

const getDomain = ( domainKey = DomainsKeys.Stats) => {
  const Environments = ExternalConfiguration.EnvDomains ?? {};
  const environment = Environments[process.env.NODE_ENV] ?? Environments['default'];
  return environment[domainKey];
}

export const Constants = {
  src: `${getDomain()}/custom_logger.js`,
};

const CustomLogger = {

  alreadyLoaded: false,
  currentPlayer: null,
  currentVideoElement: null,
  user: null,
  loggerId: null,
  getAddFunction: null,

  onPlayer: (player, videoElement) => {
    CustomLogger.currentPlayer = player;
    CustomLogger.currentVideoElement = videoElement;
    if( CustomLogger.alreadyLoaded ) CustomLogger.initialize();
  },

  onLoad: _ => {
    CustomLogger.alreadyLoaded = true;
    if( CustomLogger.currentPlayer ) CustomLogger.initialize();
  },

  setValues: (platformId, url, srcType) => {
    CustomLogger.user = platformId;
    switch( srcType) {
      case SrcTypes.Live:
        CustomLogger.loggerId = /\/((amlst|smil):)?([^/.]+)(\.(amlst|smil))?\/[^/]+.m3u8(\?[^?]*)?/.exec( url)?.[3] ?? `unprocesable live url: ${url}`;
        CustomLogger.getAddFunction = _ => window.CUSTOM_LOGGER.addStream;    // NOTE importante que esto no se ejecute hasta despues de onLoad
        break;
      case SrcTypes.Vod:
        const processAsChunked = /\/([^/]*)\/hls\/master.m3u8/.exec( url)?.[1] ?? null;
        const processAsTranmused = /\/(([^/_]*)_H,?([0-9]+,)*[0-9]+,?.mp4)(.m3u8)?/.exec( url)?.[2] ?? null;
        CustomLogger.loggerId = processAsChunked ?? processAsTranmused ?? `unprocesable vod url: ${url}`;
        CustomLogger.getAddFunction = _ => window.CUSTOM_LOGGER.addVideo;   // NOTE importante que esto no se ejecute hasta despues de onLoad
        break;
      default:;
    }
  },

  initialize: _ => {
    // console.log( 'controllers::CustomLogger::initialize');    // DEVELOP
    if( CustomLogger.getAddFunction ) {
      const addFunction = CustomLogger.getAddFunction();
      if( addFunction) {
        addFunction( CustomLogger.user, CustomLogger.loggerId, CustomLogger.currentVideoElement);
        window.CUSTOM_LOGGER.init();
      }
    }
  },

};

export default CustomLogger;
